<template>
	<div class="settings-form">
		<h2>Disable Campaign Types</h2>
		<gutter size="20px" />
		<p>Check the campaign types below that you want to disable for this account.</p>
		<template v-for="vertical_id in verticals" :key="vertical_id">
			<p-fieldset :legend="title(vertical_id)">
				<div v-for="product in products" class="flex align-items-center">
					<p-checkbox input-id="" v-model="disabled_products" :value="`${vertical_id}:${product}`" />
					<label for="" class="checkbox-label">{{ title(product) }}</label>
				</div>
			</p-fieldset>
		</template>
		<gutter size="20px" />
		<div class="actions">
			<div class="flex justify-content-start">
				<p-button label="Save Changes" @click="saveChanges" :loading="save_loading" />
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import { useMarketplaceStore } from '@/stores/marketplace';
import { mapStores } from 'pinia';
import { get } from 'lodash-es';
import { getAccountSettings, updateAccount } from '@GQL';
import { title } from '@/lib/Filters';

export default {
	name: 'CampaignTypes',
	data() {
		return {
			disabled_products: [],
			vertical_settings: {},
			products: ['data', 'call', 'live_transfer', 'ad'],
			save_loading: false,
		};
	},
	computed: {
		accountId() {
			if (this.$route.params.account_id) {
				return this.$route.params.account_id;
			} else if (this.$route.params.parent_account_id) {
				return this.$route.params.parent_account_id;
			} else {
				return this.sessionStore.account.id;
			}
		},
		verticals() {
			return Object.keys(this.vertical_settings);
		},
		...mapStores(useMarketplaceStore),
	},
	methods: {
		title,
		async getSettings() {
			const settings_result = await getAccountSettings(this.accountId, true);
			this.disabled_products = get(settings_result, 'account.settings.disabled_products', []);
			this.vertical_settings = this.$root.appStore.settings.verticals || this.marketplaceStore.settings.verticals;
		},
		async saveChanges() {
			this.save_loading = true;
			try {
				await updateAccount(this.accountId, {
					settings: {
						disabled_products: this.disabled_products,
					},
				});
				this.$toast.add({
					severity: 'success',
					summary: 'Successfully saved changes',
				});
			} catch (err) {
				this.$toast.add({
					severity: 'error',
					summary: 'Unable to save changes',
				});
			} finally {
				this.save_loading = false;
			}
		},
	},
	async mounted() {
		await this.getSettings();
	},
};
</script>

<style lang="less"></style>
